export default "__VITE_ASSET__d7_vh1U7__"